import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import file_icon from "../assets/img/pdf-icon.png";
import { useSelector } from "react-redux";
import UploadFileButton from "../component/UploadFileButton";

export default function FilePreviewList({
  formik,
  rowname,
  detail,
  id
}) {
  const { user } = useSelector((state) => state.auth);
  const [showModal, setShowModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [fileType, setFileType] = useState("");

  const handlePreview = (url) => {
    const lower = url.toLowerCase();
    if (/\.(jpg|jpeg|png)$/.test(lower)) setFileType("image");
    else if (lower.endsWith(".pdf")) setFileType("pdf");
    else if (/\.(doc|docx|xls|xlsx)$/.test(lower)) setFileType("office");
    else setFileType("other");
    setPreviewUrl(url);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handlePrint = () => {
    const printWindow = window.open(previewUrl, "_blank");
    if (printWindow) printWindow.print();
  };

  const canEdit =
    id == 0 ||
    id === undefined ||
    (detail && user?.data?.id === detail.author_id);

  const canUpload = canEdit;

  return (
    <>
      <div className="row">
        { (formik?.values?.[rowname] || []).map((itemFile, key) => (
          <div className="col-12 col-sm-4 mb-3" key={key}>
            <div className="w-100 wrapper border rounded p-2 text-center">
              <img
                src={file_icon}
                alt=""
                className="w-50 mb-2 cursor-pointer"
                onClick={() => handlePreview(itemFile)}
              />
              <p className="w-100 text-center text-truncate">
                {itemFile.length > 25 ? "..." + itemFile.slice(-25) : itemFile}
              </p>
              {canEdit && (
                <button
                  type="button"
                  className="btn btn-sm btn-danger w-100"
                  onClick={() => {
                    const list = [...formik.values[rowname]];
                    const index = list.indexOf(itemFile);
                    if (index > -1) list.splice(index, 1);
                    formik.setFieldValue(rowname, list);
                  }}
                >
                  Xóa
                </button>
              )}
            </div>
          </div>
        ))}

        {canUpload && (
          <UploadFileButton
            defaultValue={formik.values[rowname] || []}
            button_title="Tải lên"
            onSellect={(val) =>
              formik.setFieldValue(rowname, [
                ...(formik.values[rowname] || []),
                ...val,
              ])
            }
            multiple={true}
            onlytype=".pdf"
          />
        )}

        {detail &&
          detail.status === 2 &&
          (detail[rowname] || []).map((itemFile, key) => (
            <div className="col-12 col-sm-4 mb-3" key={key}>
              <div className="w-100 wrapper border rounded p-2 text-center">
                <img
                  src={file_icon}
                  alt=""
                  className="w-50 mb-2 cursor-pointer"
                  onClick={() => handlePreview(itemFile)}
                />
                <p className="w-100 text-center text-truncate">
                  {itemFile.length > 25 ? "..." + itemFile.slice(-25) : itemFile}
                </p>
                
              </div>
            </div>
          ))}
      </div>

      {/* Modal Preview */}
      <Modal
        show={showModal}
        className="modal-totrinh modal-fullcontent"
        onHide={handleClose}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 d-flex justify-content-between align-items-center">
            <h5 className="modal-title mb-0">{detail && detail.title}</h5>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={handlePrint}
            >
              <i className="bi bi-printer"></i> Xem tài liệu
            </button>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="p-0"
          style={{ height: "80vh", display: "flex", flexDirection: "column" }}
        >
          {fileType === "image" && (
            <img
              src={previewUrl}
              alt=""
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          )}

          {(fileType === "pdf" || fileType === "office") && (
            <iframe
              src={
                fileType === "office"
                  ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                      previewUrl
                    )}`
                  : previewUrl
              }
              width="100%"
              style={{ flex: 1, border: "none" }}
              title="file preview"
            ></iframe>
          )}

          {fileType === "other" && (
            <div
              className="text-center"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <p>Không thể preview loại file này.</p>
              <a
                href={previewUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Tải xuống / Mở trong tab mới
              </a>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
